export const HomeCarouselImages = [
  {
    path: "./images/selectedDal.jpeg",
  },
  {
    path: "./images/iceCream.jpeg",
  },
  {
    path: "./images/selectedDrinks.jpeg",
  },
  {
    path: "./images/selectedNoodles.jpeg",
  },
  {
    path: "./images/selectedPizza.jpeg",
  },
  {
    path: "./images/selectedIceCream2.jpeg",
  },
  {
    path: "./images/selectedPaneer.jpg",
  },
  {
    path: "./images/shakes.jpeg",
  },
];
